import React, { Component } from "react";
import RenderTable from "../common/table";
import { Icon, Label } from "semantic-ui-react";
import auth from "../../services/authService";

class InvoiceTable extends Component {
  columns = [
    {
      path: "sr",
      label: "Sr#",
      width: "1",
    },
    {
      path: "invoice_date",
      label: "Date",
      width: "1",
    },
    {
      path: "invoice_number",
      label: "Invoice#",
      width: "2",
    },
    {
      path: "client",
      label: "Client",
      width: "8",
    },
    {
      path: "attachment",
      label: "File",
      width: "1",
      content: (type) =>
        type.attachment == "" ? (
          <a
            className="ui"
            style={{
              backgroundColor: "red",
              color: "white",
              paddingLeft: "14px",
              height: "8px",
            }}
            href={"/invoices/" + type.id + "/edit"}
          >
            &nbsp;
          </a>
        ) : (
          <a
            className="ui"
            style={{
              backgroundColor: "green",
              color: "white",
              paddingLeft: "14px",
              height: "8px",
            }}
            href={
              process.env.REACT_APP_BACKEND_URL + "/storage/" + type.attachment
            }
          >
            &nbsp;
          </a>
        ),
    },
    // {
    //   path: "retention_percentage",
    //   label: "Retention %",
    //   width: "1"
    // },
    // {
    //   path: "retention_amount",
    //   label: "Retention Amount",
    //   width: "1"
    // },
    // {
    //   path: "total_amount",
    //   label: "Total Amount",
    //   width: "1"
    // },
    // {
    //   path: "vat_percentage",
    //   label: "VAT %",
    //   width: "1"
    // },
    // {
    //   path: "vat_amount",
    //   label: "VAT Amount",
    //   width: "1"
    // },
    {
      path: "grand_total",
      label: "Grand Total",
      width: "2",
    },
    {
      path: "status",
      label: "Status",
      width: "1",
      content: (type) =>
        type.status == 1 ? (
          <Label color="green">Enabled</Label>
        ) : (
          <Label color="red">Disabled</Label>
        ),
    },
    {
      key: "actions",
      width: "2",
      content: (type) => (
        <div>
          {auth.getCurrentUser().email ===
            "client-unblocker@gondalgroup.ae" && (
            <React.Fragment>
              <Icon
                name={type.status == 1 ? "hide" : "eye"}
                color={type.status == 1 ? "black" : "green"}
                className="clickable"
                onClick={() => this.props.onStatusUpdate(type)}
              />
            </React.Fragment>
          )}
          <Icon
            name="edit"
            color="blue"
            className="clickable"
            onClick={() => this.props.onUpdate(type)}
          />
          <Icon
            name="trash"
            color="red"
            className="clickable"
            onClick={() => this.props.onDelete(type)}
          />
          <Icon
            name="info"
            color="blue"
            className="clickable"
            onClick={() => this.props.onDetail(type)}
          />
        </div>
      ),
    },
  ];

  render() {
    const { types, onSort, sortColumn } = this.props;

    return (
      <RenderTable
        columns={this.columns}
        data={types}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default InvoiceTable;
